import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { Button } from "../../../components/Button";

interface OverworkingBottomSheetProps {
  modalState: UseModalState;
  onConfirm: () => void;
  onCancel: () => void;
  restrictOverworkShiftInvites?: boolean;
}

export function OverworkingBottomSheet(props: OverworkingBottomSheetProps) {
  const { modalState, onConfirm, onCancel, restrictOverworkShiftInvites = false } = props;

  const isRestricted = restrictOverworkShiftInvites;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          {!isRestricted && (
            <Button fullWidth size="large" variant="contained" onClick={onConfirm}>
              Accept Anyway
            </Button>
          )}
          <Button
            fullWidth
            size="large"
            variant={isRestricted ? "contained" : "outlined"}
            onClick={onCancel}
          >
            Go Back
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Stack spacing={6} alignItems="center" sx={{ py: 4 }}>
          <Title semibold variant="h4" component="h4" textAlign="center">
            {isRestricted ? "Cannot Accept Shift" : "Potential Overwork"}
          </Title>
          <Text
            color={(theme) => theme.palette.text.secondary}
            sx={{ textAlign: "center" }}
            variant="body1"
          >
            {isRestricted
              ? "You cannot accept this shift invite because this workplace does not allow booking for more than 17 hours in a day."
              : "Accepting this shift invite will result in you being booked for more than 17 hours in a day."}
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
